import {Button, Form, Input, Select} from "antd";
import {SearchOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {useDataGrid} from "../../../core/components/data-grid/DataGridContext";
import DeviceSelectBox from "../../device/DeviceSelectBox";
import DatePicker from "../../../core/components/DatePicker";
import {getStatusOptions} from "../../../enums/WorklistItemStatusEnum";
import ModalitySelectBox from "../../modality/ModalitySelectBox";
import HospitalSelectBox from "../../hospital/HospitalSelectBox";
import moment from 'moment';

const {RangePicker} = DatePicker;

export default function WorklistItemFilter()
{
    const {t} = useTranslation();
    const {refreshDataGrid, onFilterPageSort} = useDataGrid();
    const [form] = Form.useForm();

    const onFinish = (values) =>
    {
        const filter = { ...values };
        filter.timeFrom = values.dateRange?.[0]?.startOf('day')?.utc().toISOString();
        filter.timeTo = values.dateRange?.[1]?.endOf('day')?.utc().toISOString();
        onFilterPageSort({ filter });
    }

    const onReset = () =>
    {
        form.resetFields();
        onFilterPageSort({
            filter: {

            }
        })
    }

    return (
        <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            initialValues={{
                status: 0,
                dateType: 'created',
                dateRange: [moment().subtract(15, 'days').startOf('day'), moment().startOf('day')]
            }}
        >
            <Form.Item
                name="accessionNumber"
                label={t('Accession Number')}
            >
                <Input placeholder={t('Accession Number')}/>
            </Form.Item>

            <Form.Item
                name="patientId"
                label={t('Patient ID')}
            >
                <Input placeholder={t('Patient ID')}/>
            </Form.Item>

            <Form.Item
                name="patientName"
                label={t('Patient Name')}
            >
                <Input placeholder={t('Surname or Forename')}/>
            </Form.Item>

            <Form.Item
                name="deviceId"
                label={t('Device')}
            >
                <DeviceSelectBox allowClear autoSelect={false} />
            </Form.Item>

            <Form.Item
                name="modality"
                label={t('Modality')}
            >
                <ModalitySelectBox />
            </Form.Item>

            {/* <Form.Item
                name="hospitalName"
                label={t('Hospital Name')}
            >
                <HospitalSelectBox />
            </Form.Item> */}

            <Form.Item
                name="status"
                label={t('Status')}
            >
                <Select
                    allowClear
                    placeholder={t('Status')}
                    options={getStatusOptions().map(opt => ({
                        ...opt,
                        label: t(opt.label)
                    }))}
                />
            </Form.Item>

            <Form.Item
                name="dateType"
                label={t('Date Type')}
            >
                <Select
                    placeholder={t('Select Date Type')}
                    options={[
                        { value: 'scheduled', label: t('Scheduled') },
                        { value: 'created', label: t('Created') }
                    ]}
                />
            </Form.Item>

            <Form.Item
                name="dateRange"
                label={t('Date Range')}
            >
                <RangePicker
                    style={{width: '100%'}}
                    format="DD.MM.YYYY"
                />
            </Form.Item>

            <Form.Item>
                <Button
                    type="primary"
                    htmlType="submit"
                    icon={<SearchOutlined/>}
                    style={{width: '100%', marginBottom: 8}}
                >
                    {t('Search')}
                </Button>
                <Button
                    onClick={onReset}
                    style={{width: '100%'}}
                >
                    {t('Reset')}
                </Button>
            </Form.Item>
        </Form>
    )
}
